<!--
The agent form for creating agents. The edit agent form is different, as we won't be importing data from onboarding. Basically edits the dbo.Agent table, creates Opt logins and pull data from the onboarding portal.
//-->
<template>
    <div id="top">
        <h3>Application Details</h3>
        <v-progress-linear indeterminate v-if="loading || saving"></v-progress-linear>
        <div v-if="carriers.length > 0">
            <!-- corporate info-->
            <v-row class="d-flex" wrap dense>
                <v-col cols="12" v-if="error">
                    <v-alert type="error">
                        {{ error }}
                    </v-alert>
                </v-col>
                <v-col cols="12" v-if="warning">
                    <v-alert type="warning" v-if="warning">
                        {{ warning }}
                    </v-alert>
                </v-col>
                <v-col cols="6" wrap class="" v-if="!applicationId">
                    <q-lead-lookup :disabled="false" v-model="application.Lead" :return-object="true" label="Lead Lookup"
                        :agent-code="user.AgentCode" :all-leads="true"></q-lead-lookup>
                </v-col>
                <v-col cols="6" wrap class="" v-if="!applicationId">
                    <v-btn @click="create_referral_dialog = true">Add New Referral Lead</v-btn>
                </v-col>
                <v-col cols="12" v-if="!applicationId">
                    <h4>Lead Information</h4>
                    <p>
                        <span v-if="application.Lead" id="panel0">
                            <strong>{{ application.Lead.FirstName }} {{ application.Lead.LastName }} ({{ application.Lead.LeadCode }})</strong><br />
                            {{ application.Lead.Street }}<br />
                            {{ application.Lead.City }}, {{ application.Lead.State }} {{ application.Lead.Zip }}<br />
                            Phone: {{ application.Lead.Phone }}<br />
                            Email: {{ application.Lead.Email }}<br />
                        </span>
                        <strong v-else>Please choose a lead to attach this application to. You can also create a referral
                            lead if the lead is not in our system. </strong>
                    </p>
                </v-col>
            </v-row>
            <v-form lazy-validation v-model="valid" ref="form" :disabled="loading || saving || application.Lead == null">
                <v-row class="d-flex" wrap dense>
                    <v-col cols="12" class="pr-10">
                        <h4>Client Information</h4>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field dense label="Applicant's First Name*" v-model="application.FirstName"
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field dense label="Applicant's Last Name*" v-model="application.LastName"
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field dense label="Street Address*" v-model="application.Address"
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field dense label="City*" v-model="application.City" :rules="[rules.required]">
                                </v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-select dense label="State*" :items="states" v-model="application.State"
                                    :rules="[rules.required]"></v-select>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field dense label="Zip*" v-model="application.Zip"
                                    :rules="[rules.required, rules.zip]"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field dense label="Cell Phone" v-model="application.CellPhone"
                                    :rules="[rules.required, rules.phone]"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field dense label="Home Phone" v-model="application.HomePhone"
                                    :rules="[rules.phone]"></v-text-field>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field dense label="Email" v-model="application.Email"
                                    :rules="[rules.required, rules.email]"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <q-date-picker dense v-model="application.BirthDate" label="Birth Date">
                                </q-date-picker>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-divider class="my-6"></v-divider>
                    <v-col cols="12">
                        <h4>Policy Information</h4>
                        <v-row class="d-flex justify-center">
                            <v-col cols="12" v-if="hasRole(['Stuff', 'SuperAdmin'])">
                                <q-date-picker dense v-model="application.IssuedDate" label="Issued Date" />
                            </v-col>
                            <v-col cols="6">
                                <q-date-picker dense v-model="application.ApplicationDate" label="Application Date" />
                            </v-col>
                            <v-col cols="6">
                                <q-date-picker dense v-model="application.SubmittedDate" label="Submitted Date" />
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox label="I am the original writing agent"
                                    v-model="application.OriginalAgentIsAgent"></v-checkbox>
                                <q-agent-lookup v-if="!application.OriginalAgentIsAgent" dense :filters="{ 'Status': 'Active,Available,Lapsed,Stalled,Terminated' }"
                                    label="Original Writing Agent" v-model="application.OriginalWritingAgent"
                                    :rules="[rules.required]" placeholder="Start typing to Search for Agent"
                                    :add-self="true"
                                    :tenant-wide="true"></q-agent-lookup>
                            </v-col>
                            <v-col cols="6">
                                <v-checkbox label="Purchased to protect mortgage?"
                                    v-model="application.PurchtoProtectMort"></v-checkbox>
                                <v-select label="SaleType" :items="sale_types" v-model="application.SaleType"
                                    :rules="[rules.required]"></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select label="Carrier*" :items="carriers" :return-object="true"
                                    v-model="application.Carrier" item-text="CarrierName" :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-select :disabled="application.Carrier == null" :return-object="true"
                                    label="Product*" :items="products" item-text="Product" v-model="application.Product"
                                    :rules="[rules.required]"></v-select>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field label="Policy Number" v-model="application.PolicyNumber"
                                    :rules="[rules.required]"></v-text-field>
                            </v-col>
                            <v-col cols="3">
                                <v-checkbox label="eApp"
                                    v-model="application.eApp"></v-checkbox>
                            </v-col>
                            <v-col cols="7">
                                <v-card class="pa-7 elevation-5">
                                    <v-row>
                                        <v-col cols="12" v-if="false">
                                            <v-select :items="policy_types" dense label="Policy Type*"
                                                v-model="application.Type" :rules="[rules.required]"></v-select>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field type="number" prepend-inner-icon="fas fa-dollar-sign" outlined label="FaceAmount*"
                                                v-model="application.FaceAmount" :rules="[rules.required, rules.number]"></v-text-field>
                                        </v-col>
                                        <v-col cols="6">
                                            <v-text-field type="number" prepend-inner-icon="fas fa-dollar-sign" outlined label="APV*"
                                                v-model="application.APV" :rules="[rules.required, rules.number]"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" v-if="maybe_mistake">
                                            <v-alert type="error">APV is more than the Face Amount. Are you sure you put in the correct values?</v-alert>
                                        </v-col>
                                        <v-col cols="12">
                                            <q-file-upload ref="dropzone" text="Attach eApp PDF" :upload-url="'/api/private/agent/' + this.agentCode + '/application/pdf_upload'" :params="{}" accepted-files="application/vnd.ms-word,.jpg,.png,.gif,.docx,.doc,.xlsx,.pdf" upload-name="document" :max-files="1" v-on:complete="uploadComplete" v-on:fileadded="uploading=true;" v-on:error="uploadError"></q-file-upload>
                                            <v-progress-linear indeterminate v-if="uploading"></v-progress-linear>
                                        </v-col>
                                        <v-col cols="12" v-if="typeof application.ApplicationPDFURL === 'string'">
                                            <v-btn small  @click.stop="downloadPdf()">
                                                <v-icon>fas fa-download</v-icon> Download Application
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea label="Policy Notes" v-model="application.PolicyNotes"></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                            <v-col cols="7">
                                <v-expansion-panels>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Cross Sale Transaction
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row>
                                                <v-col cols="6">
                                                    <q-agent-lookup dense :filters="{ 'Status': 'Active,Available,Lapsed,Stalled,Terminated' }"
                                                        label="Cross Sale Agent" v-model="application.CrossSaleAgent2" :tenant-wide="true"
                                                        :rules="[]" placeholder="Start typing to Search for Agent"
                                                        :add-self="true"></q-agent-lookup>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field type="number" append-icon="fas fa-percentage" outlined label="Cross Sale Percentage"
                                                        v-model="application.CrossSalePercentage" :rules="[rules.number]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                    <v-expansion-panel>
                                        <v-expansion-panel-header>
                                            Split Sale Transaction
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row>
                                                <v-col cols="6">
                                                    <q-agent-lookup dense :filters="{ 'Status': 'Active,Available,Lapsed,Stalled,Terminated' }"
                                                        label="Split Agent" v-model="application.Agent2" :tenant-wide="true"
                                                        :rules="[]" placeholder="Start typing to Search for Agent"
                                                        :add-self="true"></q-agent-lookup>
                                                </v-col>
                                                <v-col cols="6">
                                                    <v-text-field type="number" append-icon="fas fa-percentage" outlined label="Percentage"
                                                        v-model="application.Percentage" :rules="[rules.number]"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-form>
            <v-divider class="my-6"></v-divider>
            <!--personal info-->
            <v-row class="d-flex" wrap dense>
                <v-col cols="12" class="text-center">
                    <v-progress-linear indeterminate v-if="saving"></v-progress-linear>
                    <v-btn v-if="!applicationId" color="secondary" class="mr-5" @click="saveApplication(false, true)" :disabled="saving">
                        Save & Duplicate
                        <v-icon right>fas fa-copy</v-icon>
                    </v-btn>
                    <v-btn v-if="!applicationId" color="primary" class="mr-5" @click="saveApplication(false, false)" :disabled="saving">
                        Save & New
                        <v-icon right>fas fa-plus</v-icon>
                    </v-btn>
                    <v-btn v-if="!applicationId" class="mr-5" color="primary" @click="saveApplication(true)" :disabled="saving">
                        Save & Close
                    </v-btn>
                    <v-btn class="mr-5" color="primary" @click="saveApplication(true)" :disabled="saving">
                        Save
                    </v-btn>
                    <v-btn class="mr-5" @click="$emit('close')" :disabled="saving">
                        Cancel
                    </v-btn>
                </v-col>
            </v-row>
            <q-create-lead-referral :agent="this.user.Agent" v-model="create_referral_dialog" :licensing="null"
                v-on:refresh="setReferralLead"></q-create-lead-referral>
        </div>
    </div>
</template>
<script>
import QFileUpload from '@/components/utils/QFileUpload.vue'
import QDatePicker from '@/components/utils/QDatePicker.vue'
import QLeadLookup from '@/components/utils/QLeadLookup.vue'
import QuilityAPI from '@/store/API/QuilityAPI.js'
import moment from 'moment'
import StateOptions from '@/store/StateOptions'
import StateAbbreviations from '@/store/StateAbbreviations'
import rules from '@/components/utils/ValidationRules'
import QCreateLeadReferral from '@/components/utils/QCreateLeadReferral.vue'
import QAgentLookup from '@/components/utils/QAgentLookup.vue'


export default {
    props: ['applicationId'],
    data() {
        return {
            saving: false, //for progress bars
            loading: false,
            warning: null,
            error: null,
            valid: true, //these hold whether the various forms are valid or not.
            states: StateOptions, //for the state drop down list
            state_abbreviations: StateAbbreviations,
            rules: rules, //validation rules imported.
            create_referral_dialog: false,
            carriers: [],
            uploading : false,
            application: {
                ID : null,
                AgentCode : null,
                AgentID : null,
                SubmittedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                ApplicationDate: moment().format('YYYY-MM-DD HH:mm:ss'),
                FirstName: null,
                LastName: null,
                Source: null,
                Lead: null,
                ExcludeFromStatsInd: false,
                Address: null,
                City: null,
                State: null,
                Zip: null,
                County: null,
                HomePhone: null,
                CellPhone: null,
                Age: null,
                BirthDate: null,
                Email: null,
                Carrier: null,
                Product: null,
                SaleType: 'Telephone Sale',
                PurchToProtectMort: true,
                FaceAmount: null,
                APV: null,
                Percentage: null,
                Agent2: null,
                SplitPercent: null,
                CrossSalePercentage: null,
                CrossSaleAgent2: null,
                Status: null,
                eApp: true,
                FirstTimeCarrier: null,
                PaidInd: null,
                PolicyNumber: null,
                PolicyNotes: null,
                Type: 'Mortgage Protection',
                IssuedDate: null,
                OriginalAgentIsAgent: false,
                OriginalWritingAgent: null,
                ApplicationPDFURL : null,
                freeze : false
            }
        }
    },
    mounted: function () {
        var g = this
        if(this.applicationId){
            this.getCarrierMap().then(function(){
                g.loadApplication(g.applicationId)
            })
        }else{
            this.getCarrierMap();
        }

    },
    computed: {
        'agentCode' : function(){
            if (typeof this.application.AgentCode != 'undefined' && this.application.AgentCode != null){
                return this.application.AgentCode;
            }
            return this.user.Agent.AgentCode
        },
        'products': function () {
            if (this.application.Carrier != null) {
                return this.application.Carrier.Products.sort()
            }
            return [];
        },
        'product_subtypes': function () {
            if (this.application.Product != null) {
                return this.application.Product.ProductSubtypes.sort()
            }
            return [];
        },
        'policy_types': function () {
            return [
                'Final Expense',
                //'QMS',
                'Life',
                'Debt Free Life',
                'Spanish-MP',
                'Mortgage Protection',
            ]
        },
        'sale_types': function () {
            return [
                'Video Sale',
                'In Person',
                'Telephone Sale',
                'Live Transfer Sale'
            ]
        },
        'maybe_mistake' : function(){
            if (Number(this.application.APV) > Number(this.application.FaceAmount)){
                return true
            }
            return false;
        }
    },
    methods: {
        reset() {
            this.warning = null
            this.saving = false
            this.application.ID = null
            this.application.Lead = null
            this.prepopulateWithLead();
        },
        prepopulateWithLead() {
            if (this.application.Lead == null) {
                this.application.FirstName = null
                this.application.LastName = null
                this.application.Source = null
                this.application.LeadCode = null
                this.application.Address = null
                this.application.City = null
                this.application.State = null
                this.application.Zip = null
                this.application.HomePhone = null
                this.application.CellPhone = null
                this.application.Age = null
                this.application.BirthDate = null
                this.application.Email = null
            } else {
                this.application.FirstName = this.application.Lead.FirstName
                this.application.LastName = this.application.Lead.LastName
                this.application.Address = this.application.Lead.Street
                this.application.City = this.application.Lead.City
                this.application.State = this.application.Lead.State
                this.application.Zip = this.application.Lead.Zip
                this.application.CellPhone = this.application.Lead.Phone
                this.application.Age = this.application.Lead.Age
                this.application.BirthDate = this.application.Lead.BirthDate
                this.application.Email = this.application.Lead.Email
            }
            if(this.$refs.dropzone){
                this.$refs.dropzone.removeAllFiles();
            }
            this.application.Carrier = null
            this.application.Product = null
            this.application.ExcludeFromStatsInd = false
            this.application.Percentage = null
            this.application.FaceAmount= null
            this.application.APV= null
            this.application.Percentage= null
            this.application.Agent2= null
            this.application.SplitPercent= null
            this.application.CrossSalePercentage= null
            this.application.CrossSaleAgent2= null
            this.application.Status= null
            this.application.eApp= true
            this.application.FirstTimeCarrier= null
            this.application.PaidInd= null
            this.application.PolicyNumber= null
            this.application.PolicyNotes= null
            this.application.Type= 'Mortgage Protection'
            this.application.IssuedDate = null
            this.application.OriginalAgentIsAgent = false
            this.application.OriginalWritingAgent = null
            this.application.ApplicationPDFURL = null
            this.application.ID = null
        },
        //translates a full name state into an abbreviation.
        getStateAbbreviation(state) {
            if (this.states.indexOf(state) > -1) {
                return state
            }
            if (typeof this.state_abbreviations[state] != 'undefined') {
                return this.state_abbreviations[state];
            }
            return null
        },
        setReferralLead: function (lead) {
            this.application.Lead = lead
        },
        getCarrierMap: function () {
            if (this.loading) {
                return new Promise((resolve, reject) => {})
            }
            this.goToTop()
            var g = this
            g.loading = true
            return QuilityAPI.getCarriersMap().then(function (json) {
                //lets sort by carrier name.
                g.carriers = json.data.sort((a, b) => (a.CarrierName > b.CarrierName) ? 1 : (a.CarrierName === b.CarrierName) ? 0 : -1 );
                g.loading = false;
            }).catch(function (e) {
                g.loading = false;
                g.showError(e);
            })
        },
        goToTop: function() {
            document.getElementById("top").scrollIntoView();
        },
        saveApplication(close_app, duplicate){
            var g = this
            var validated = this.$refs.form.validate();
            if (!validated){
                this.warning = 'Please fill out all required fields!';
                this.goToTop()
                return
            }
            if (this.application.ID == null && this.application.ApplicationPDFURL == null){
                this.warning = 'Please upload the eApp PDF Document!';
                this.goToTop()
                return
            }
            this.saving=true
            QuilityAPI.saveApplication(this.agentCode, this.application).then(function(json){
                if (json.Success !== true){
                    g.saving=false
                    g.warning = null
                    g.showError("We could not save the application. Please check your entries!")
                    return
                }
                g.saving=false
                g.warning = null
                if(close_app){
                    g.$emit("close");
                }
                if(duplicate){
                    g.application.ID = null
                    g.ApplicationPDFURL = null
                    g.showInfo("Application Saved! You can now modify and submit another app for this lead.")
                    g.goToTop()
                }else{
                    g.showInfo("Application Saved!")
                    g.reset()
                    g.goToTop()
                }
            }).catch(function(err){
                console.log("error", err)
            })
        },
        uploadComplete(d){
            this.application.ApplicationPDFURL = d.data.document.FilePath
            this.uploading = false
        },
        uploadError(response){
            this.showError(response.message.message)
            this.uploading = false
            this.$refs.dropzone.removeFile(response.file)
        },
        loadApplication(id){
            var g = this
            g.loading = true
            g.freeze = true
            QuilityAPI.getApplication(id).then(function(json){
                g.loading = false
                g.application = json.data
                //set the carrier
                var carrier = g.getCarrierById(g.application.CarrierID)
                //set the product and product subtype
                var product = g.getProductById(carrier, g.application.CarrierProductID)
                g.application.Carrier = carrier;
                g.application.CarrierProduct = product;
                g.application.OriginalWritingAgent = g.application.OrigWritingAgentAgentCode
                //don't worry about uploading eapp
                //check for split agent2
                g.application.Agent2 = g.application.Agent2AgentCode
                //check for crosssale agent2
                g.application.CrossSaleAgent2 = g.application.CrossSaleAgent2AgentCode
                setTimeout(() => g.freeze = false, 500)
            }).catch(function(err){
                g.loading = false
                console.log("error", err)
            })
        },
        downloadPdf: function() {
            QuilityAPI.downloadApplicationPdf(this.application)
                .then( resp => {
                    const url = window.URL.createObjectURL(new Blob([resp.data]));
                    const link = document.createElement('a');
                    const filename = this.application.ApplicationPDFURL.split('/').pop();
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(err => {
                    if (err.response.status === 403) {
                        this.showError('You do not have permission to download this file.');
                    } else {
                        this.showError('There was an error downloading the file.');
                    }
                });
        },
        getCarrierById : function(id){
            var carrier = null;
            var g = this
            this.carriers.forEach(function(c, ix){
                if (c.ID == id){
                    carrier = g.carriers[ix];
                }
            })
            return carrier
        },
        getProductById : function(carrier, id){
            var product = null;
            var g = this
            carrier.Products.forEach(function(p, ix){
                if (p.ID == id){
                    product = carrier.Products[ix];
                }
            })
            return product
        },
    },
    watch: {
        'application.Lead.LeadCode': function (newV) {
            if (this.freeze){
                return
            }
            this.$nextTick(this.prepopulateWithLead);
        },
        'application.Carrier': function () {
            if (this.freeze){
                return
            }
            this.application.Product = null
        },
        'application.Product': function () {
            if (this.freeze){
                return
            }
            this.application.ProductSubtype = null
        },
        'applicationId' : function(newV){
            var g = this;
            this.reset()
            if (newV > 0){
                this.getCarrierMap().then(function(){
                    g.loadApplication(newV)
                })

            }
        }
    },
    components: {
        QDatePicker,
        QLeadLookup,
        QCreateLeadReferral,
        QAgentLookup,
        QFileUpload
    }
}
</script>
